import { post,get,postJson,postLogin} from './axios'

const RESOURCE_BASE_PATH = '/sms-ai-content-record'

// 查询短信生成历史记录接口（取前20条）
export const AIList = p => get(`${RESOURCE_BASE_PATH}/list`, p);

// 生成AI短信文案接口
export const monkey = p => postJson(`${RESOURCE_BASE_PATH}/buildContent`, p);

// 根据请求ID查询应答信息接口
export const AI = p => get(`${RESOURCE_BASE_PATH}/getResponse/${p}`);

// 重新生成文案接口
export const AIAgain = p => get(`${RESOURCE_BASE_PATH}/reBuild/${p}`);

// 人群分析列表
export const crowdEffectPage = p => postJson(`/yunqi-ai-api/crowdEffect/page`, p);